module.exports = __webpack_public_path__ + "img/Make_this_field_required.9602978d.svg";